// Anuncios en Meta, base (migración 20261025a_ads_base.sql; diseño en docs/estrategia/META_ADS.md). Textos y cuentas de la pantalla «Anuncios».
import { money } from './ownerReport';

export { money };

const CONNECTION = {
  sin_conectar: { label: 'Sin conectar', tone: 'text-seryi-text' },
  conectada: { label: 'Conectada', tone: 'text-emerald-400' },
  caducada: { label: 'Acceso caducado', tone: 'text-amber-300' },
  error: { label: 'Con error', tone: 'text-rose-300' }
};
export const connectionStatus = (status) => CONNECTION[status] || CONNECTION.sin_conectar;

// Aviso cuando el acceso a Meta vence pronto (los accesos de larga duración duran unos 60 días y hay que renovarlos).
export const tokenWarning = (expiresAt, now = Date.now()) => {
  const t = expiresAt ? new Date(expiresAt).getTime() : NaN;
  if (!Number.isFinite(t)) return '';
  const days = Math.ceil((t - now) / 86400000);
  if (days <= 0) return 'El acceso a tu cuenta de Meta ya venció: hay que volver a conectarla.';
  if (days <= 7) return `El acceso a tu cuenta de Meta vence en ${days} ${days === 1 ? 'día' : 'días'}: renuévalo para no perder la sincronización.`;
  return '';
};

// Color de la barra del mes: verde hasta el 70 %, ámbar hasta el 100 %, rojo si ya pasó el tope.
export const budgetTone = (percent) => {
  const p = Number(percent) || 0;
  return p > 100 ? 'bg-rose-500' : p >= 70 ? 'bg-amber-500' : 'bg-seryi-green';
};

// Costo por conversación contra la meta del negocio (si la tiene): «bien», «alto» o sin comparación.
export const costVsGoal = (cost, goal) => {
  const c = cost == null || cost === '' ? NaN : Number(cost);
  const g = Number(goal);
  if (!Number.isFinite(c) || !(g > 0)) return { label: '', tone: 'text-seryi-text' };
  return c <= g ? { label: `Dentro de tu meta de ${money(g)}`, tone: 'text-emerald-400' } : { label: `Por encima de tu meta de ${money(g)}`, tone: 'text-amber-300' };
};

export const costText = (cost) => (cost == null || !Number.isFinite(Number(cost)) ? 'Sin conversaciones' : money(cost));

// Periodo por defecto de la pantalla: los últimos 30 días hasta hoy (hora de Colombia), con «hasta» exclusivo.
export const defaultPeriod = (now = new Date()) => {
  const bogota = new Date(now.getTime() - 5 * 3600 * 1000);
  const day = (offset) => new Date(Date.UTC(bogota.getUTCFullYear(), bogota.getUTCMonth(), bogota.getUTCDate() + offset)).toISOString().slice(0, 10);
  return { from: day(-29), to: day(1) };
};

// ── Crear campañas (migración 20261028a_ads_campaigns.sql) ─────────────────────────────────────────────
const CAMPAIGN_STATUS = {
  borrador: { label: 'Borrador', tone: 'text-seryi-text', note: 'Aún no se ha enviado a Meta.' },
  por_publicar: { label: 'En cola', tone: 'text-amber-300', note: 'Se está creando en Meta (en pausa).' },
  publicando: { label: 'Creándose en Meta', tone: 'text-amber-300', note: 'Esto toma un par de minutos.' },
  pausada: { label: 'Creada en pausa', tone: 'text-emerald-400', note: 'Ya está en tu cuenta de Meta, sin gastar. Revísala y actívala allá cuando quieras.' },
  error: { label: 'Con error', tone: 'text-rose-300', note: '' },
  cancelada: { label: 'Cancelada', tone: 'text-seryi-text', note: '' }
};
export const campaignStatus = (status) => CAMPAIGN_STATUS[status] || CAMPAIGN_STATUS.borrador;

// El presupuesto diario más alto que acepta la base: el tope por día y, si la campaña corriera todo el mes (× 30), el tope del mes.
export const maxDailyBudget = (limits) => {
  const daily = Number(limits?.daily_cap);
  const monthly = Number(limits?.monthly_cap);
  const byDay = Number.isFinite(daily) && daily > 0 ? daily : 30000;
  const byMonth = Number.isFinite(monthly) && monthly > 0 ? Math.floor(monthly / 30) : 20000;
  return Math.min(byDay, byMonth);
};

export const MIN_DAILY_BUDGET = 1000;

// Mensaje de lo que falta o está mal en el formulario de una campaña, o '' si está lista para guardar como borrador.
export const campaignProblem = (f, limits) => {
  if (String(f.name || '').trim().length < 3) return 'Ponle un nombre a la campaña (mínimo 3 letras).';
  if (!f.textId) return 'Elige el texto del anuncio (se genera en Contenido).';
  if (!f.imageId) return 'Elige la imagen del anuncio (se genera en Contenido).';
  if (String(f.headline || '').trim().length > 40) return 'El titular puede tener hasta 40 letras.';
  const budget = Number(f.budget);
  const max = maxDailyBudget(limits);
  if (!Number.isInteger(budget) || budget < MIN_DAILY_BUDGET) return `El presupuesto diario mínimo es ${money(MIN_DAILY_BUDGET)}.`;
  if (budget > max) return `El presupuesto diario máximo para tu negocio es ${money(max)} (según los topes por día y por mes).`;
  if (String(f.city || '').trim().length < 2) return 'Escribe la ciudad donde quieres mostrar el anuncio.';
  const radius = Number(f.radius);
  if (!Number.isInteger(radius) || radius < 17 || radius > 80) return 'El radio va de 17 a 80 km (el mínimo que acepta Meta para una ciudad).';
  const lo = Number(f.ageMin);
  const hi = Number(f.ageMax);
  if (!Number.isInteger(lo) || !Number.isInteger(hi) || lo < 18 || hi > 65 || lo > hi) return 'Las edades van de 18 a 65 y la mínima no puede pasar de la máxima.';
  return '';
};
